export const getPath = (path: string) =>
  `/${["admin", path].filter((str) => str).join("/")}`;
